import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CommonFunctions from '@util/functions.common';
import TableReport from '@componentes/TableReport';
import IntlMessage from '../../../../../helpers/intlMessage';

function Padrao ({ lista, isDescarte = true }) {
  const headerListItens = [
    <IntlMessage id = "dashboards.disposalMaterials.table.exam"/>,
    <IntlMessage id = "dashboards.disposalMaterials.table.bottle"/>,
    <IntlMessage id = "dashboards.disposalMaterials.table.patient"/>,
    <IntlMessage id = "dashboards.disposalMaterials.table.socialName"/>,
    <IntlMessage id = "dashboards.disposalMaterials.table.material"/>,
    <IntlMessage id = "dashboards.disposalMaterials.table.expirationDate"/>,
    <IntlMessage id = "dashboards.disposalMaterials.table.deliveryDate"/>,
    <IntlMessage id = "dashboards.disposalMaterials.discardDate"/>
  ];
  const [headerList, setHeaderList] = useState(headerListItens);
  const [titulo, setTitulo] = useState('');
  const tab = useSelector(state => state.descarteCommon.tab);

  function carregarTitulo () {
    if (!isDescarte) {
      setTitulo(<IntlMessage id = "dashboards.disposalMaterials.discardReports"/>);
    } else {
      setTitulo(<IntlMessage id = "dashboards.disposalMaterials.discardedReports"/>);
    }
  }

  useEffect(() => {
    carregarTitulo();
    if (tab === '1') {
      setHeaderList(headerListItens.filter(x => x !== <IntlMessage id = "dashboards.disposalMaterials.disposalDate"/>));
    } else {
      setHeaderList(headerListItens);
    }
  }, [tab]);

  return (
    <TableReport
      title={titulo}
      assinatura={<IntlMessage id = "dashboards.disposalMaterials.signatureCRM"/>}
      headerList={headerList}
    >
      {lista.map((item, i) => (
        <tr key={i}>
          <td>{item.numeroExame}</td>
          <td>{item.idFrasco}</td>
          <td>{item.paciente}</td>
          <td>{item.pacienteNomeSocial}</td>
          <td>{item.nomeMaterial}</td>
          <td>{CommonFunctions.formatData(item.dataVencimento)}</td>
          <td>{item.dataRecebimento}</td>
          {tab !== '1' && <td>{item.dataDescarte}</td>}
        </tr>
      ))}
    </TableReport>
  );
}

Padrao.propTypes = {
  lista: PropTypes.array.isRequired
};

Padrao.defaultProps = {
  lista: []
};

export default Padrao;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/Padrao/index.js